import { Outlet } from "react-router-dom";
import { SimulationProvider } from "./contexts/Simulation";
import { APIProvider } from "@vis.gl/react-google-maps";

const SimContainer = () => {
  return (
    <SimulationProvider>
      <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} version="3.64">
        <Outlet/>
      </APIProvider>
    </SimulationProvider>
  )
}

export default SimContainer;